import Container from "@client/content/Containers/container";
import { getContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { type WithIsEditMode } from "@client/types";
import * as React from "react";
import Content from "./Content/container";

import "./style.less";

export type MapProps = RootContainerProps &
  WithIsEditMode & {
    areCommentsAllowed: boolean;
    className: string;
    hasPost: boolean;
  };

export interface ActionProps {}

type Props = ActionProps & MapProps;
export default (props: Props) => {
  const { areCommentsAllowed, hasPost, className } = props;

  return (
    <Container className={className} {...getContainerProps(props)}>
      {areCommentsAllowed && hasPost ? (
        <Content {...props} />
      ) : props.isEditMode ? (
        !hasPost ? (
          <span>{`There's no post. Please make sure the current URL (${window.location.href}) contains a permalink`}</span>
        ) : (
          <span>{`Comments are disabled for this post`}</span>
        )
      ) : null}
    </Container>
  );
};
